<template>
  <div
    class="modal fade"
    id="editNodModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    role="dialog"
    aria-labelledby="editNodModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content" v-if="show">
        <div class="modal-header shadow-sm">
          <h6 class="modal-title font-weight-bold" id="editNodModalLabel">
            <p class="mb-1">Edit Case</p>
          </h6>
        </div>
        <div class="modal-body">
          <div class="row mx-0 mb-3 flex-nowrap">
            <div class="col-4">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small mb-1">
                    District<sup class="text-danger">*</sup>
                  </label>
                </div>
                <div class="dropdown rounded w-100">
                  <button
                    class="w-100 btn btn-sm btn-block bg-white dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3"
                    style="font-size: 0.875rem; color: #495057"
                    type="button"
                    id="dropdownDistrictButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span v-if="models.district">
                      {{
                        districts.find(
                          (district) => district.id == models.district
                        ).name
                      }}
                    </span>
                    <span v-else class="text-muted">-- Select district</span>
                  </button>
                  <div
                    class="dropdown-menu py-0 w-100 shadow-sm p-0"
                    aria-labelledby="dropdownDistrictButton"
                    style="height: 200px; overflow: hidden; font-size: 0.875rem"
                  >
                    <input
                      class="form-control form-control-sm"
                      placeholder="Search"
                      v-model="districtSearchModel"
                    />
                    <div style="height: calc(100% - 43px); overflow-y: auto">
                      <button
                        v-for="district in computedDistricts"
                        :key="`select-district-${district.id}`"
                        class="border-bottom dropdown-item px-3 py-2"
                        :class="{
                          'bg-subtle': models.district == district.id,
                        }"
                        style="color: #495057"
                        @click="models.district = district.id"
                      >
                        {{ district.name }}
                        <i
                          class="fas fa-check text-primary ml-2 small"
                          v-if="models.district == district.id"
                        />
                      </button>
                      <div
                        class="dropdown-item py-2 small text-center text-muted font-italic px-3 py-2 fs-8"
                      >
                        <span v-if="computedDistricts.length > 0">
                          End of list
                        </span>
                        <span v-else>No district found</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-8">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small mb-1">
                    Road<sup class="text-danger">*</sup>
                  </label>
                </div>
                <div class="dropdown rounded w-100">
                  <button
                    class="w-100 btn btn-sm btn-block bg-white dropdown-toggle position-relative d-flex justify-content-between align-items-center overflow-hidden px-3"
                    style="font-size: 0.875rem; color: #495057"
                    type="button"
                    id="dropdownRoadButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    :disabled="!models.district"
                  >
                    <div class="text-truncate">
                      <span v-if="models.road">
                        {{ roads.find((road) => road.id == models.road).name }}
                      </span>
                      <span v-else class="text-muted">-- Select road</span>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu py-0 w-100 shadow-sm p-0"
                    aria-labelledby="dropdownRoadButton"
                    style="height: 200px; overflow: hidden; font-size: 0.875rem"
                  >
                    <input
                      class="form-control form-control-sm"
                      placeholder="Search"
                      v-model="roadSearchModel"
                    />
                    <div style="height: calc(100% - 43px); overflow-y: auto">
                      <button
                        v-for="road in computedRoads"
                        :key="road.id"
                        class="border-bottom dropdown-item d-flex justify-content-between align-items-center px-3 py-2"
                        :class="{
                          'bg-subtle': models.road == road.id,
                        }"
                        style="color: #495057"
                        @click="models.road = road.id"
                      >
                        {{ road.name }}
                        <i
                          class="fas fa-check text-primary ml-2 small"
                          v-if="models.road == road.id"
                        />
                      </button>
                      <div
                        class="dropdown-item py-2 small text-center text-muted font-italic px-3 py-2 fs-8"
                      >
                        <span v-if="computedRoads.length > 0">
                          End of list
                        </span>
                        <span v-else>No road found</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1">
                  NOD Serial No.<sup class="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="SerialNo"
                  placeholder="Enter NOD serial no."
                  v-model="models.serialNo"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="NODDate">Date</label>
                <button
                  class="btn btn-sm bg-white w-100 d-flex justify-content-between align-items-center"
                  @click="showDatetimeSelector = true"
                >
                  <span>
                    {{ formatDate(models.timestamp) || "Click to select date" }}
                  </span>
                  <i class="fas fa-calendar-alt" />
                </button>
              </div>
            </div>
          </div>
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1">
                  Group Type<sup class="text-danger">*</sup>
                </label>
                <select
                  id="GroupType"
                  class="form-select form-select-sm"
                  v-model="models.groupType"
                >
                  <option :value="null" disabled>-- Select group type</option>
                  <option :value="type" v-for="type in groupTypes">
                    {{ type }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="TypeOfDefect">
                  Type of Defect
                </label>
                <input
                  type="text"
                  step="any"
                  min="0"
                  class="form-control form-control-sm"
                  id="TypeOfDefect"
                  placeholder="Enter type of defect"
                  v-model="models.typeOfDefect"
                />
              </div>
            </div>
          </div>
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="TypeOfDefect">
                  Coordinate
                </label>
                <div class="row">
                  <div class="col px-2">
                    <input
                      type="text"
                      step="any"
                      min="0"
                      class="form-control form-control-sm"
                      id="lat"
                      placeholder="Enter latitude"
                      v-model="models.lat"
                    />
                  </div>
                  <div class="col px-2">
                    <input
                      type="text"
                      step="any"
                      min="0"
                      class="form-control form-control-sm"
                      id="lng"
                      placeholder="Enter longitude"
                      v-model="models.lng"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer shadow">
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="closeModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="saveChanges()"
            :disabled="isProcessing"
          >
            <div
              class="spinner-border spinner-border-sm text-light"
              v-if="isProcessing"
            ></div>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>

    <datetime-selector
      v-if="showDatetimeSelector"
      :date="models.timestamp"
      @close="dateSelected"
    />
  </div>
</template>

<script>
import { Modal } from "bootstrap/dist/js/bootstrap.esm.min";
import DatetimeSelector from "@/components/DatetimeSelector";
import MediaViewer from "@/components/MediaViewer";
import Swal from "sweetalert2";

export default {
  name: "edit-nod-modal",
  props: ["show", "nodCase"],
  components: { MediaViewer, DatetimeSelector },
  data() {
    return {
      modal: null,
      showDatetimeSelector: false,
      isInitial: true,
      isProcessing: false,
      districts: [],
      roads: [],
      districtSearchModel: null,
      roadSearchModel: null,
      groupTypes: ["KJP", "Emergency", "Electrical"],
      models: {
        cases: [],
        district: null,
        road: null,
        groupType: null,
        typeOfDefect: null,
        timestamp: null,
        lat: null,
        lng: null,
        serialNo: null,
      },
      emptyModels: {
        cases: [],
        district: null,
        road: null,
        groupType: null,
        typeOfDefect: null,
        timestamp: null,
        lat: null,
        lng: null,
        serialNo: null,
      },
    };
  },
  watch: {
    isProcessing: {
      handler() {
        this.Helper.toggleLoadingSpinner(this.isProcessing);
      },
      deep: true,
      immediate: true,
    },
    show: {
      async handler() {
        if (this.modal && this.show) {
          await this.getDistricts();

          this.models = JSON.parse(JSON.stringify(this.emptyModels));

          if (this.nodCase) {
            this.isInitial = true;

            this.$nextTick(() => {
              Object.keys(this.models).forEach((key) => {
                this.models[key] = this.nodCase[key] || null;

                if (this.models.district) {
                  this.getRoads();
                }
              });

              this.$nextTick(() => {
                this.isInitial = false;
              });
            });
          }

          this.modal.show();
        } else if (this.modal) {
          this.modal.hide();

          this.districts = [];

          this.roads = [];

          this.models = JSON.parse(JSON.stringify(this.emptyModels));
        }
      },
      immediate: true,
    },
    "models.district": {
      async handler() {
        if (this.models.district) {
          const _district =
            this.districts.find(
              (district) => district.id == this.models.district
            ) || {};

          if (!_district.roads?.find((road) => road.id == this.models.road)) {
            this.models.road = null;

            await this.getRoads();
          }

          this.districtSearchModel = null;
        }
      },
      immediate: false,
      deep: true,
    },
    "models.road": {
      async handler() {
        if (this.models.road) {
          this.roadSearchModel = null;
        }
      },
      immediate: false,
    },
  },
  computed: {
    computedDistricts() {
      let list = JSON.parse(JSON.stringify(this.districts));

      if (this.districtSearchModel) {
        list = list.filter((l) =>
          l.name.toLowerCase().includes(this.districtSearchModel.toLowerCase())
        );
      }

      return list;
    },
    computedRoads() {
      let list = JSON.parse(JSON.stringify(this.roads));

      if (this.roadSearchModel) {
        list = list.filter((l) =>
          l.name.toLowerCase().includes(this.roadSearchModel.toLowerCase())
        );
      }

      return list;
    },
  },
  methods: {
    async getDistricts() {
      this.isProcessing = true;

      return this.API.get(this.API.endpoints().allDistricts)
        .then((retVal) => {
          this.districts = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    async getRoads() {
      this.isProcessing = true;

      this.roads =
        this.districts.find((district) => district.id == this.models.district)
          ?.roads || [];

      this.isProcessing = false;

      return;
    },
    formatDate(timestamp) {
      return this.Helper.formatDate(timestamp);
    },
    closeModal(response) {
      if (!this.isProcessing) {
        this.$emit("close", response);
      }
    },
    async saveChanges() {
      this.isProcessing = true;

      await this.API.put(`nod-cases/${this.nodCase.id}`, this.models);

      this.isProcessing = false;

      Swal.fire("NOD Updated", "", "success").then(() => {
        this.closeModal(true);
      });
    },
  },
  mounted() {
    this.modal = new Modal(document.getElementById("editNodModal"));
  },
};
</script>